// extracted by mini-css-extract-plugin
module.exports = {"areaButtons":"addCategory_areaButtons__1aCD3"};